import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from "../../config/app-settings.js";
import { Card, CardBody } from '../../components/card/card'
import styled from 'styled-components'
import { Navigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useDispatch } from 'react-redux';
import { login } from '../../redux/slice/authSlice.js';
import { getRoleModuleSidebar } from '../../redux/action/roleModuleAction.js';
import Cookies from 'js-cookie';

const BodyLogin = styled.div`
width: 100%;
height: 100vh;
align-items: center;
background-image: linear-gradient(180deg, rgba(50, 70, 80, 0.9) 0%, rgb(13, 16, 27) 100%);
;
margin-left: 0;
&:before{
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: -5;
  background-image: url('/assets/img/jpo/Jembatan.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
`
const NewLogin = () => {
    const context = useContext(AppSettings);
    const [redirect, setRedirect] = useState(false);
    const dispatch = useDispatch()
    const [userLogin, setUserLogin] = useState([]);

    const validation = useFormik({
      // enableReinitialize : use this flag when initial values needs to be changed
      enableReinitialize: true,
  
      initialValues: {
        username: userLogin.username ,
        password: userLogin.password ,
      },
      validationSchema: Yup.object({
        username: Yup.string().required("Please Enter Your User Name"),
        password: Yup.string().required("Please Enter Your Password"),
      }),
      onSubmit: (values) => {
        // console.log(values)
        dispatch(login({username: values.username, password: values.password}));
      },
    });

    const token = Cookies.get('accessToken');
    if (token) {
      return <Navigate exact from="/login" to="/dashboard" />;
    }
    return (
      <BodyLogin className='row justify-content-center'>
        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
          <div class="row align-items-end">
            <div className='col-xs-3 col-sm-3 col-md-3 col-lg-3'>
              &nbsp;
            </div>
            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
              {/* <Card className="mb-3">
                <CardBody> */}
                  <form 
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <div className="row mb-3" style={{borderBottom: '1px solid rgba(var(--bs-border-color-rgb), 0.3)'}}>
                      {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
                        <img src="/assets/img/user/BinaMarga.png" alt="" style={{ alignSelf: 'center', paddingBottom: '10px', height: 120}}/>
                      </div> */}
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
                        <h2>LOGIN</h2>
                        <p> Untuk Keamanan, Tolong verifikasi data diri anda.</p>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Nama <span className="text-danger">*</span>
                      </label>
                      <input
                        name="username"
                        type="text"
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        placeholder="Enter Username"
                        id="username"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.username || ""}
                        invalid={
                          validation.touched.username && validation.errors.username
                            ? true
                            : false
                        }
                      />
                      {validation.touched.username && validation.errors.username ? (
                        <div class="invalid-feedback">
                        {validation.errors.username}
                        </div>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <div className="d-flex">
                        <label className="form-label">
                          Kata Sandi <span className="text-danger">*</span>
                        </label>
                      </div>
                      <input
                        type="password"
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        placeholder="Enter Password"
                        id="password"
                        name="password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.password || ""}
                        invalid={
                          validation.touched.password && validation.errors.password
                            ? true
                            : false
                        }
                      />
                      {validation.touched.password && validation.errors.password ? (
                        <div class="invalid-feedback">
                        {validation.errors.password}
                        </div>
                      ) : null}
                    </div>
                    <button
                      type="submit"
                      className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3"
                    >
                      Masuk
                    </button>
                  </form>
            </div>
          </div>
        </div>
        <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>

              <div className="row">
                <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                  &nbsp;
                </div>
                <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8" style={{padding: 10}}>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
                      <img src="/assets/img/user/BinaMarga.png" alt="" style={{ alignSelf: 'center', paddingBottom: '10px', height: 200}}/>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center mb-3">
                      <h2>JPO - DINAS BINA MARGA</h2>
                    </div>
                  </div>

                  <Card className="mb-3">
                    <CardBody>
                      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{padding: 20}}>
                        <h4>SELAMAT DATANG</h4>
                        <p style={{fontSize: 20}}>Aplikasi ini merupakan Aplikasi berbasis Web apps yang bertujuan untuk memonitoring segala aktivitas yang ada di dalam JPO (Jembatan Penyebrangan Orang)</p>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
        </div>
      </BodyLogin>
    )
}

export default NewLogin